import styled from "styled-components"

interface Props {
  completed?: boolean
  active?: boolean
  step?: number
  small?: boolean
}

export const StatusDot = styled.div<Props>`
  position: relative;
  width: 24px;
  height: 24px;
  border: 2px solid
    ${({completed, active, theme}) => {
      if (active) {
        return theme.colors.secondary1
      }
      if (completed) {
        return theme.colors.greys.black
      }
      return theme.colors.primary2
    }};
  background: ${({completed, theme}) => (!completed ? theme.colors.greys.white : theme.colors.secondary1)};
  border-radius: 100px;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${({theme, active}) =>
    active &&
    `
  :before {
    content: " ";
    position: absolute;
    top: -${theme.spacing.one};
    left: -${theme.spacing.one};
    right: -${theme.spacing.one};
    bottom: -${theme.spacing.one};
    border: 1px solid ${theme.colors.secondary1};
    border-radius: 50%;
  }
  `}
`

export const Line = styled.div<Props>`
  position: relative;
  height: 2px;
  width: ${({step, small}) => {
    if (step && step > 2) {
      if (small) {
        return "105px"
      }
      return "210px"
    }
    return "310px"
  }};
  top: 10px;
  background: ${({completed, theme}) => (completed ? theme.colors.primary2 : theme.colors.greys.mediumLight)};
`

export const Relative = styled.div`
  position: relative;
`

export const Absolute = styled.div<Props>`
  position: absolute;
  width: ${({step}) => (step && step > 2 ? "165px" : "200px")};
  left: ${({step}) => (step && step > 2 ? "-60px" : "-90px")};
  top: 35px;
  text-align: center;
`

export const RelativeBody = styled.div`
  position: relative;
  top: 30px;
  width: 250px;
`
